import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Tooltip } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import FolderIcon from "@mui/icons-material/Folder";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";

export const GroupFolderTooltipIcon = (props) => {
  const { t } = useTranslation("cms");
  return (
    <SvgIcon component={"span"} fontSize="inherit" {...props}>
      <Tooltip
        arrow
        disableInteractive
        title={t("item.expandGroupedAssetIcon")}
      >
        <Box>
          <FolderIcon />
        </Box>
      </Tooltip>
    </SvgIcon>
  );
};

export const GroupFolderOpenTooltipIcon = (props) => {
  const { t } = useTranslation("cms");
  return (
    <SvgIcon component={"span"} fontSize="inherit" {...props}>
      <Tooltip
        arrow
        disableInteractive
        title={t("item.collapseGroupedAssetIcon")}
      >
        <Box>
          <FolderOpenIcon />
        </Box>
      </Tooltip>
    </SvgIcon>
  );
};
